module.exports = __webpack_public_path__ + "img/person.ba7fd4b6.png";